const SESSION_PREFIX = 'epc_weekly_wbs_expanded_'

export function weeklyUiSessionKey(projectId) {
  if (!projectId) {
    return null
  }
  return `${SESSION_PREFIX}${projectId}`
}

export function defaultWeeklyUiSessionState() {
  return {
    expanded: [],
    activities: [],
    subactivities: [],
    assignments: [],
  }
}

export function readWeeklyUiSession(projectId) {
  const key = weeklyUiSessionKey(projectId)
  if (!key) {
    return defaultWeeklyUiSessionState()
  }

  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) {
      return defaultWeeklyUiSessionState()
    }

    const parsed = JSON.parse(raw)
    return normalizeWeeklyUiSessionState(parsed)
  } catch (error) {
    return defaultWeeklyUiSessionState()
  }
}

export function normalizeWeeklyUiSessionState(parsed) {
  const state = defaultWeeklyUiSessionState()

  if (Array.isArray(parsed)) {
    state.expanded = parsed
    return state
  }

  if (!parsed || typeof parsed !== 'object') {
    return state
  }

  if (Array.isArray(parsed.expanded)) {
    state.expanded = parsed.expanded
  }
  if (Array.isArray(parsed.activities)) {
    state.activities = parsed.activities
  }
  if (Array.isArray(parsed.subactivities)) {
    state.subactivities = parsed.subactivities
  }
  if (Array.isArray(parsed.assignments)) {
    state.assignments = parsed.assignments
  }

  return state
}

export function writeWeeklyUiSession(projectId, state) {
  const key = weeklyUiSessionKey(projectId)
  if (!key) {
    return
  }

  const normalized = normalizeWeeklyUiSessionState(state)
  const hasAny = normalized.expanded.length
    || normalized.activities.length
    || normalized.subactivities.length
    || normalized.assignments.length

  try {
    if (!hasAny) {
      sessionStorage.removeItem(key)
      return
    }
    sessionStorage.setItem(key, JSON.stringify(normalized))
  } catch (error) {
    // ignorar quota / modo privado
  }
}

/**
 * Sincroniza una sección del estado (p. ej. expanded, activities) con los ids abiertos en el nivel actual.
 */
export function mergeWeeklyUiSessionSection(projectId, section, expandedIds, currentLevelIds) {
  if (!projectId || !section) {
    return
  }

  const state = readWeeklyUiSession(projectId)
  const stored = new Set(Array.isArray(state[section]) ? state[section] : [])
  const currentLevel = new Set(currentLevelIds || [])

  currentLevel.forEach((id) => stored.delete(id))
  ;(expandedIds || []).forEach((id) => stored.add(id))

  state[section] = Array.from(stored)
  writeWeeklyUiSession(projectId, state)
}

export function removeWeeklyUiSessionSubactivitiesForParent(projectId, parentActivityId) {
  if (!projectId || parentActivityId == null) {
    return
  }

  const state = readWeeklyUiSession(projectId)
  const prefix = `${parentActivityId}-`
  state.subactivities = state.subactivities.filter((key) => !String(key).startsWith(prefix))
  writeWeeklyUiSession(projectId, state)
}
